'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';
interface InactivityWarningDialogProps {
  open: boolean;
  secondsRemaining: number;
  onStay: () => void;
  onLogout: () => void;
}
export function InactivityWarningDialog(t0) {
  const $ = _c(22);
  const {
    open,
    secondsRemaining,
    onStay,
    onLogout
  } = t0;
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  let t1;
  if ($[0] !== minutes || $[1] !== seconds) {
    t1 = minutes > 0 ? `${minutes}:${String(seconds).padStart(2, "0")}` : `${seconds}s`;
    $[0] = minutes;
    $[1] = seconds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const countdown = t1;
  let t2;
  if ($[3] !== onStay) {
    t2 = o => {
      if (!o) {
        onStay();
      }
    };
    $[3] = onStay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogTitle className="flex items-center gap-2"><Clock className="h-5 w-5 text-amber-500" />Session Expiring Soon</DialogTitle>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== countdown) {
    t4 = <DialogHeader>{t3}<DialogDescription>You've been inactive. Your session will expire in{" "}<span className="font-semibold text-foreground">{countdown}</span>.</DialogDescription></DialogHeader>;
    $[6] = countdown;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onLogout) {
    t5 = <Button variant="outline" onClick={onLogout}>Log out now</Button>;
    $[8] = onLogout;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onStay) {
    t6 = <Button onClick={onStay}>Stay signed in</Button>;
    $[10] = onStay;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <DialogFooter className="flex gap-2 sm:justify-end">{t5}{t6}</DialogFooter>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <DialogContent className="sm:max-w-md" onInteractOutside={_temp}>{t4}{t7}</DialogContent>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== open || $[19] !== t2 || $[20] !== t8) {
    t9 = <Dialog open={open} onOpenChange={t2}>{t8}</Dialog>;
    $[18] = open;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp(e) {
  return e.preventDefault();
}